module.exports = __webpack_public_path__ + "img/dp158_03.d3365eb3.jpg";